import { render, staticRenderFns } from "./NormalAchievementsTab.vue?vue&type=template&id=362c4254"
import script from "./NormalAchievementsTab.vue?vue&type=script&lang=js"
export * from "./NormalAchievementsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports